import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const workday = defineConnector({
  identifier: "workday",
  name: "Workday",
  tagLine: "Enterprise HR and finance",
  logo,
  protocol: "http",
  tags: ["it", "productivity"],
  defaultUrlPattern: () => "https://.*\\.workday\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your Workday details",
      items: [
        {
          kind: "hostname",
          label: "Hostname",
          required: true,
          placeholder: "wd2-impl-services1.workday.com",
          target: { kind: "configuration", field: "hostname" },
          helperText:
            "Your Workday hostname (e.g., wd2-impl-services1.workday.com or wd5-services1.myworkday.com).",
        },
        {
          kind: "input",
          label: "Tenant name",
          required: true,
          placeholder: "your-tenant",
          target: { kind: "configuration", field: "tenant" },
          helperText:
            "Your Workday tenant name, found in your URL path after /ccx/ (e.g., https://wd2-impl-services1.workday.com/ccx/api/v1/mycompany/… → mycompany).",
        },
      ],
    },
    {
      title: "Enter your Integration System User credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Ask your Workday admin to create an Integration System User (ISU) with permission to call the REST and SOAP APIs you need. Enter that account's username and password below.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          placeholder: "isu_3b@your-tenant",
          target: { kind: "secrets", field: "username" },
          helperText:
            "Typically in the form `username@tenant` (Workday includes the tenant in the username).",
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ hostname, tenant }) =>
      `https://${hostname}/ccx/api/v1/${tenant}/workers/me`,
  },
  publicEnvVars: ({ hostname, tenant }) => ({
    WORKDAY_URL: hostname ? `https://${hostname}` : "",
    WORKDAY_TENANT: tenant || "",
  }),
});
